import { all, fork } from 'redux-saga/effects';
import watchApiCall from './apiSaga';

export default function* rootSaga() {
    yield all([
        fork(watchApiCall),
        // fork(anotherSaga), // Nếu bạn có các saga khác
    ]);
}